import { __rest } from "tslib";
import Button from 'antd/lib/button';
import React from 'react';
import { connectField, filterDOMProps } from 'uniforms';

var ListDel = function ListDel(_a) {
  var disabled = _a.disabled,
      name = _a.name,
      parent = _a.parent,
      props = __rest(_a, ["disabled", "name", "parent"]);

  var fieldIndex = +name.slice(1 + name.lastIndexOf('.'));
  var limitNotReached = !disabled && !(parent.minCount >= parent.value.length);
  return React.createElement(Button, Object.assign({
    disabled: !limitNotReached || disabled,
    onClick: function onClick() {
      return limitNotReached && parent.onChange([].concat(parent.value.slice(0, fieldIndex)).concat(parent.value.slice(1 + fieldIndex)));
    }
  }, filterDOMProps(props)));
};

ListDel.defaultProps = {
  icon: 'delete',
  shape: 'circle-outline',
  size: 'small',
  type: 'ghost'
};
export default connectField(ListDel, {
  includeParent: true,
  initialValue: false
});